var render, staticRenderFns
import script from "./WeeklyHoursByInstructorChart.vue?vue&type=script&lang=js&"
export * from "./WeeklyHoursByInstructorChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0866272",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0866272')) {
      api.createRecord('d0866272', component.options)
    } else {
      api.reload('d0866272', component.options)
    }
    
  }
}
component.options.__file = "src/components/dashboard/WeeklyHoursByInstructorChart.vue"
export default component.exports